import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../rootReducer";

export const selectFileTypes = createSelector(
    [
        (store: RootState) => store.fileTypes.fileTypesList,
        (store: RootState) => store.fileTypes.searchText,
        (store: RootState) => store.fileTypes.isSignableFilter,
        (store: RootState) => store.fileTypes.notSignableFilter,
        (store: RootState) => store.fileTypes.enabledFilter,
        (store: RootState) => store.fileTypes.disabledFilter,

    ],
    (fileTypesList, searchText, isSignableFilter, notSignableFilter, enabledFilter, disabledFilter) => {
        const data = fileTypesList?.filter(
            ({ name, isSignable, enabled }) => {
                // Filtro por nombre 
                if (
                    searchText
                    && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
                ) {
                    return false;
                }

                if (
                    isSignableFilter && !notSignableFilter
                    && !isSignable
                ) {
                    return false;
                }

                if (
                    !isSignableFilter && notSignableFilter
                    && isSignable
                ) {
                    return false;
                }

                if (
                    enabledFilter && !disabledFilter
                    && !enabled
                ) {
                    return false;
                }
                if (
                    !enabledFilter && disabledFilter
                    && enabled
                ) {
                    return false;
                }

                return true;
            })

        // Ordena la lista alfabéticamente
        const orderedList = [...data].sort((a, b) => {
            if (a.name && b.name && a.name < b.name) {
                return -1;
            }
            if (a.name && b.name && a.name > b.name) {
                return 1;
            }
            return 0;
        });

        return orderedList;
    }
);